import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { BottoneAPI, Trad, BaseComponent, ChiamaAPI, Tipo } from '../components/';

interface ICostantiState {
}

export class Costanti extends React.Component<Glob.IRouteGlobaleProps, ICostantiState> {

    public constructor(props: any) {
        super(props);
        this.OnRisListaTipi = this.OnRisListaTipi.bind(this);
    }

    private OnRisListaTipi(sender: ChiamaAPI, dati: Dati.CRisAPIListaTipo, datiNuovi: boolean): React.ReactNode {
        let CSharp: string = "public static class Tipi {\n" + dati.Dati.map(dato => "///<summary>" + dato.ID_TipoContesto + " - " + dato.Valore + "</summary>\npublic const string " + dato.ID_Chiave.replace(/-/g, "_") + " = \"" + dato.ID_Chiave + "\";").join("\n") + "\n}";
        let TypeScript: string = dati.Dati.map(dato => "///<summary>" + dato.ID_TipoContesto + " - " + dato.Valore + "</summary>\nexport const Tipi_" + dato.ID_Chiave.replace(/-/g, "_") + ": string = \"" + dato.ID_Chiave + "\";").join("\n");
        return <div>
            C# (Dati.cs):<br />
            <textarea readOnly value={CSharp} cols={180} rows={10}></textarea><br />
            TypeScript (Globale.tsx):<br />
            <textarea readOnly value={TypeScript} cols={180} rows={10}></textarea><br />
        </div>
    }

    public render() {
        return <div>
            <ChiamaAPI URL="/api/Tipi/ListaTipi" Aggiornare={1} OnRis={this.OnRisListaTipi} />
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/form/Costanti.tsx